import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-display text-2xl text-neon-pink pulse-glow">LOADING.</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
